import React, { useEffect, useState } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { ReactComponent as NoOfEmploeee } from '../../../Assets/Icons/noOfEmployeeicon.svg';
import { ReactComponent as Morgage } from '../../../Assets/Icons/morgage.svg';
import { ReactComponent as Delete } from '../../../Assets/Icons/delete.svg';
import { NavRent } from '../../../Assets/Icons/navrentIcon';
import { User, userData } from '../../../Storeredux/constants/actionTypes';
import { getDashboardData } from '../../../Services/hooks/Dashboard';
import { useSelector } from 'react-redux';
import { RootState } from '../../../Storeredux/reducers/rootReducer';
import { ObjectType } from '../../../Services/constant/serviceType';
import { ArrowRight, Eye } from 'iconsax-react';
import { Link } from 'react-router-dom';
import Loader from '../../../Components/Loader/Loader';

function CompanyDashboard() {
  const UserState = useSelector((state: RootState) => state.user as userData);
  const { user } = UserState;
  const [dashboardData, setDashboardData] = useState<ObjectType>({});
  const [loading, setLoading] = useState(true);
  console.log('dashboard', dashboardData);

  const dash = async () => {
    setLoading(true);
    const response = await getDashboardData(user.company_id);
    if (response.success) {
      setLoading(false);
      setDashboardData(response.result);
    }
    setLoading(false);
    console.log(response.result, 'hhhh');
  };

  useEffect(() => {
    dash();
  }, []);
  return (
    <div className='overflow-scroll'>
      {/* cards */}
      <div className='p-3.5 md:p-3.5 lg:p-7 lg:px-0 lg:pb-0 pb-3 '>
        <div className='md:flex-row flex-wrap gap-3 lg:gap-6 md:flex-nowrap flex w-full lg:w-11/12 mx-auto rounded mb-1.5'>
          <div className='py-2 px-4 lg:py-3 lg:px-7 xl:py-5 xl:px-10 border-b md:border-b-0 border-r border-custom bg-white flex justify-between w-[48%] md:w-full' style={{ boxShadow: '0px 2px 10px 0px #0000001A' }}>
            <div className='flex flex-col justify-between pb-2.5'>
              <h1 className='font-semibold uppercase text-xs md:text-xs lg:text-sm'>No Of Employees</h1>
              <p className={'font-bold text-xl'}>{dashboardData.total_employees || 0}</p>
            </div>
            <div className='flex flex-col items-end'>
              <NoOfEmploeee/>
              {/*<button className={'text-white text-sm bg-custom-darkgreen py-2 px-8 rounded my-1'}>Add Employee</button>*/}
            </div>
          </div>
          <div className="bg-[#AA1B03] py-2 px-4 lg:py-3 lg:px-7 xl:py-5 xl:px-10 border-b md:border-b-0 border-r border-custom text-white flex justify-between w-[48%] md:w-full" style={{ boxShadow: '0px 2px 10px 0px #0000001A' }}>
            <div className="flex flex-col justify-between pb-2.5">
              <h1 className="font-semibold uppercase text-xs md:text-xs lg:text-sm">Employees on Rent</h1>
              <p className={'font-bold text-xl'}>{dashboardData.employees_on_rent || 0}</p>
            </div>
            <div className="flex flex-col justify-center items-center">
              <NavRent color={'#fff'} size={52} />
            </div>
          </div>
          <div className="py-2 px-4 lg:py-3 lg:px-7 xl:py-5 xl:px-10 border-b md:border-b-0 border-r border-custom bg-white flex justify-between w-[50%] md:w-full"
            style={{ boxShadow: '0px 2px 10px 0px #0000001A' }}>
            <div className="flex flex-col justify-between pb-2.5">
              <h1 className="font-semibold uppercase text-xs md:text-xs lg:text-sm">Employees on Mortgage</h1>
              <p className={'font-bold text-xl'}>{dashboardData.employees_on_mortgage || 0}</p>
            </div>
            <div className="flex flex-col justify-center items-center">
              <Morgage />
            </div>
          </div>
        </div>
      </div>

      {/* recent investment */}
      <div className="w-11/12 md:w-11/12 lg:w-11/12 mx-auto ">
        <div className=' py-2 border border-custom-grey rounded-custom bg-white'
             style={{ boxShadow: '0px 2px 10px 0px #0000001A' }}>
          <div className={'flex justify-between items-center py-6 px-3.5'}>
            <h1 className=" text-sm  ">
              Employees on Monthly Rent
            </h1>
            <Link to={'/app/allemployees'} className={'flex text-sm gap-2 items-center cursor-pointer'}>
              <p>View all</p>
              <ArrowRight size="14" color="#000"/>
            </Link>
          </div>
          <table className="w-full">
            <thead className='font-semibold text-xxs lg:text-xs bg-custom-light-green uppercase'>
            <tr className=''>
              <th className='py-4'>S/N</th>
              <th>Employee Name</th>
              <th>Employee Email</th>
              <th>Type</th>
              <th>amount per month</th>
              <th >action</th>
            </tr>
            </thead>

            {
              loading ? (
                <tbody>
                  <tr>
                    <td colSpan={10} className="py-5 px-2">
                      <div className="flex flex-col justify-center items-center w-full py-16">
                        <Loader />
                      </div>
                    </td>
                  </tr>
                </tbody>
              ) :
                dashboardData.employees?.length !== 0 ?
                  <tbody>
                  {
                    dashboardData.employees?.map((historyData: User, index: any) =>
                      <tr key={index}
                          className="font-semibold text-xxs sm:text-xs text-center uppercase border-b-2 border-custom-light-green">
                        <td className="py-4">{index + 1}</td>
                        <td>{historyData?.name}</td>
                        <td>{historyData?.email}</td>
                        <td>{historyData?.employee[0]?.house_type || 'Full-Time'}</td>
                        <td>{historyData?.employee[0]?.amount_per_month || 0}</td>
                        <td>
                          <div className={'flex justify-center items-center gap-4'}>
                            {/*<Edit size="20" color="#000"/>*/}
                            <Link to={`/app/allemployees/${historyData?.id}`}>
                              <Eye size="20" color="#000" variant="Bold" />
                            </Link>
                            <Delete style={{ width: '20px', height: '20px', fill: '#000' }} />
                          </div>
                        </td>
                      </tr>,
                    )
                  }
                  </tbody>
                  :
                  <tbody>
                  <tr>
                    <td colSpan={6} className="">
                      <div className="flex flex-col justify-center items-center w-full py-16">
                        <p className="text-sm pt-1">No Employee Yet </p>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                }

                </table>
              </div>
      </div>
    </div>
  );
}

export default CompanyDashboard;
